import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const NurseStationPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page nurseStationPage">
        <Header />
        <div className="page-header">Healthcare Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Nurse Station</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            As nurses work on a rotating schedule to ensure 
            24/7 nurse station coverage; technology delivers 
            fast, fresh, and convenient food service, 
            supporting rotating menus that keep options 
            flexible and appealing.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Nurse Station", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default NurseStationPage;